import intl from 'react-intl-universal';
import { useLearningTeam } from './hooks/useLearningTeam';
import useSnackbarNotification from 'Hooks/useSnackbarNotification';
import PageTitle from 'Molecules/PageTitle/PageTitle';
import Loader from 'Molecules/Loader/Loader';
import DetailsPage from 'Molecules/DetailsPage/DetailsPage';
import EditTeamHeader from '../../EditTeam/EditTeamHaeder';
import BasicInformationForm from './components/BasicInformationForm/BasicInformationForm';
import Divider from 'Atoms/Divider';
import TeamMembers from './components/TeamMembers/TeamMembers';

const LearningTeamDetailPage = () => {
  const {
    learningTeamName,
    isLearningTeamLoading,
    learningTeam,
    notificationProps,
    isNotificationVisible,
  } = useLearningTeam();
  const { SnackbarNotification } = useSnackbarNotification();
  return (
    <div className='h-full flex flex-col w-full min-w-0'>
      <PageTitle
        titleComponent={`${intl.get('ENTITIES.TEAM', {
          num: 2,
        })} / ${learningTeamName}`}
        className='sticky top-0 left-0 right-0'
      />
      {isLearningTeamLoading && <Loader />}
      {!isLearningTeamLoading && learningTeam && (
        <DetailsPage
          topBar={<EditTeamHeader isBusinessTeam={false} team={learningTeam} />}
          hasFooter={false}
          content={
            <div className='h-full min-w-0 bg-neutral-white'>
              <BasicInformationForm team={learningTeam} />
              <Divider className='mt-8' />
              <TeamMembers />
            </div>
          }
        />
      )}
      {isNotificationVisible && notificationProps && (
        <SnackbarNotification
          {...notificationProps}
          title={notificationProps.title ?? ''}
        />
      )}
    </div>
  );
};

export default LearningTeamDetailPage;
